import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Quote from "@/pages/Quote";
import Admin from "@/pages/Admin";
import LogoPage from "@/pages/LogoPage";
import QRPage from "@/pages/QRPage";
import WhatsAppRedirect from "@/pages/WhatsAppRedirect";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import MobileActionBar from "@/components/MobileActionBar";

function FloatingContact() {
  const { pathname } = useLocation();
  // Hide floating widgets on admin & internal pages so they don't clutter workflow.
  const hidden = pathname.startsWith("/admin") || pathname.startsWith("/whatsapp") || pathname === "/logo";
  if (hidden) return null;
  return (
    <>
      <WhatsAppFloat />
      <MobileActionBar />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/logo" element={<LogoPage />} />
        <Route path="/qr" element={<QRPage />} />
        <Route path="/whatsapp" element={<WhatsAppRedirect />} />
      </Routes>
      <FloatingContact />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
